import sleep from "~/utils/sleep";

export type Deferred<T> = {
  promise: Promise<T>;
  resolve: (_: T) => void;
  reject: (..._: unknown[]) => void;
};

export default <T = void>() => {
  let resolutionState: "pending" | "resolved" | "rejected" = "pending";
  let resolutionValue: T;

  const deferred = {
    promise: new Promise<T>(executor),
    resolve: (value: T) => {
      if (resolutionState !== "pending") {
        return;
      }

      resolutionState = "resolved";
      resolutionValue = value;
    },
    reject: (..._: unknown[]) => {
      if (resolutionState !== "pending") {
        return;
      }

      resolutionState = "rejected";
    },
  } as Deferred<T>;

  return deferred;

  async function executor(resolve: (_: T) => void, reject: () => void) {
    await sleep();

    deferred.resolve = resolve;
    deferred.reject = reject;

    if (resolutionState === "pending") {
      return;
    }

    if (resolutionState === "resolved") {
      resolve(resolutionValue as T);

      return;
    }

    reject();
  }
};
